// extracted by mini-css-extract-plugin
export default {"Container":"InfoBox_Container__qn1X7"};